import {
  InputGroup,
  InputLeftElement,
  Input,
  InputRightElement,
  Icon,
} from '@chakra-ui/react';
import { SearchMd } from '@kula-ai/icons/outline/SearchMd';
import { XIcon } from '@heroicons/react/solid';
import { useRef, useEffect, useState } from 'react';
import { debounce } from 'lodash-es';

export const SearchFilter = ({
  applySearch,
  searchTerm,
  debounceTime = 250,
  inputProps,
}) => {
  const userInput = useRef();
  const [hasContent, setHasContent] = useState(false);

  useEffect(() => {
    userInput.current.value = searchTerm;
  }, [searchTerm]);

  const HandleOnSearch = debounce(() => {
    setHasContent(userInput.current?.value?.length > 0);
    applySearch({ searchTerm: userInput.current?.value });
  }, debounceTime);

  const defaultStyles = {
    fontSize: '14px',
    paddingInlineStart: '.75em',
    pt: '1.125em',
    pb: '1.125em',
    height: '2.13em',
    borderRadius: '8px',
  };

  return (
    <>
      <InputGroup width="328px" borderRadius="sm" h="32px" {...inputProps}>
        <InputLeftElement pointerEvents="none" maxH="100%">
          <Icon as={SearchMd} color="secondary-800" width="20px" />
        </InputLeftElement>
        <Input
          type="text"
          h="32px"
          ref={userInput}
          onChange={HandleOnSearch}
          placeholder="Search"
          _placeholder={{
            opacity: 1,
            fontSize: 'sm',
            fontWeight: 'medium',
            color: 'secondary-400',
          }}
          bg="secondary-50"
          borderColor="secondary-200"
          _hover={{
            bg: 'secondary-50',
            borderColor: 'secondary-200',
          }}
          _focus={{
            bg: 'secondary-50',
            borderColor: 'secondary-200 !important',
            boxShadow: 'none !important',
          }}
          _focusVisible={{
            bg: 'secondary-50',
            borderColor: 'secondary-200',
          }}
          data-test-id="search-filter-input"
          {...defaultStyles}
        />
        <InputRightElement maxH="100%">
          {hasContent && (
            <Icon
              as={XIcon}
              w="16px"
              h="16px"
              cursor="pointer"
              // color="#8D8D8D"
              color="secondary-800"
              onClick={() => {
                userInput.current.value = '';
                HandleOnSearch();
              }}
            />
          )}
        </InputRightElement>
      </InputGroup>
    </>
  );
};
